import React from 'react';

import { type SurfaceModule } from '@atlassian/surface-sdk';
import { deriveMutateOfChild } from '@atlassian/surface-sdk/utils';

import { type Actions } from '../../../index';
import { AppRecommendationsSectionHeader } from '../app-recommendation-section-header';
import { type AppRecommendationsSectionHeaderProps } from '../app-recommendation-section-header/types';
import { AppRecommendationsList } from '../app-recommendations-list';
import { type AppRecommendationsProps } from '../types';

import { type AppRecommendationsWithTitleProps } from './types';

export const AppRecommendationsWithTitle: SurfaceModule<
	AppRecommendationsWithTitleProps,
	AppRecommendationsWithTitleProps,
	Actions
> = ({ mutate, title, noAppsTitle, headingLevel, context, actionBus, ...rest }) => {
	const AppRecommendationSectionHeaderMutate = deriveMutateOfChild<
		AppRecommendationsSectionHeaderProps,
		AppRecommendationsWithTitleProps
	>({ mutate, mutationArgs: { noAppsTitle, title, headingLevel } });

	const AppRecommendationsMutate = deriveMutateOfChild<
		AppRecommendationsProps,
		AppRecommendationsWithTitleProps
	>({ mutate, mutationArgs: rest });

	return (
		<>
			<AppRecommendationsSectionHeader
				title={title}
				noAppsTitle={noAppsTitle}
				mutate={AppRecommendationSectionHeaderMutate}
				context={context}
				headingLevel={headingLevel}
				actionBus={actionBus}
			/>
			<AppRecommendationsList
				{...rest}
				actionBus={actionBus}
				context={context}
				mutate={AppRecommendationsMutate}
			/>
		</>
	);
};
